import axiosClient from "./axiosClient";

export const listarPagosExtra = () => axiosClient.get("/pagos-extra").then((r) => r.data);

export const crearPagoExtra = (mes, anio, montoEsperado) =>
  axiosClient.post("/pagos-extra", { mes, anio, montoEsperado }).then((r) => r.data);

export const eliminarPagoExtra = (pagoExtraId) => axiosClient.delete(`/pagos-extra/${pagoExtraId}`);

export const actualizarMontoPagoExtra = (pagoExtraId, montoEsperado) =>
  axiosClient.put(`/pagos-extra/${pagoExtraId}`, { montoEsperado });

export const listarGastosPagoExtra = (pagoExtraId) =>
  axiosClient.get(`/pagos-extra/${pagoExtraId}/gastos`).then((r) => r.data);

export const crearGastoPagoExtra = (pagoExtraId, monto, descripcion) =>
  axiosClient.post(`/pagos-extra/${pagoExtraId}/gastos`, { monto, descripcion }).then((r) => r.data);

export const eliminarGastoPagoExtra = (pagoExtraGastoId) =>
  axiosClient.delete(`/pagos-extra/gastos/${pagoExtraGastoId}`);

export const actualizarGastoPagoExtra = (pagoExtraGastoId, monto, descripcion) =>
  axiosClient.put(`/pagos-extra/gastos/${pagoExtraGastoId}`, { monto, descripcion });
